import {toast} from 'react-toastify';

const handleStatus = (status, logout, navigate) => {
  if (status === 403) {
    toast.error(
      'Access denied. You do not have permission to perform this action.'
    );
    navigate('/');
  }
  if (status === 500) {
    toast.error('Internal server error. Please try again later.');
    navigate('/');
  }
  if (status === 401) {
    toast.error('Unauthorized access. Please log in again.');
    localStorage.removeItem('token');
    logout();
  }
};

export const dateConvertorForBirthdayPopup = (date) => {
  const splitDate = date.split('/');
  const correctDate = `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
  return correctDate;
};

export default handleStatus;
